import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import {
  detectAppLanguage,
  getLocaleForLanguage,
  saveAppLanguage,
} from "./detectLanguage.js";

import ruCommon from "./locales/ru/common.json";
import enCommon from "./locales/en/common.json";

const initialLanguage = detectAppLanguage();

i18n
  .use(initReactI18next)
  .init({
    lng: initialLanguage,

    fallbackLng: "en",

    supportedLngs: [
      "ru",
      "en",
    ],

    defaultNS: "common",

    resources: {
      ru: {
        common: ruCommon,
      },

      en: {
        common: enCommon,
      },
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    returnNull: false,
  });

export function getAppLanguage() {
  return i18n.resolvedLanguage === "ru"
    ? "ru"
    : "en";
}

export function setAppLanguage(language) {
  const nextLanguage =
    saveAppLanguage(language);

  if (!nextLanguage) {
    return;
  }

  void i18n.changeLanguage(
    nextLanguage
  );
}

export function getAppLocale() {
  return getLocaleForLanguage(
    getAppLanguage()
  );
}

export default i18n;

